import { Select } from '@/components/ui/select';
import { Label } from '@/components/ui/label';
import { useProjectManagers } from '@/features/leads/hooks/useProjectManagers';

interface EstimatorSelectorProps {
  selectedUserId: number | null;
  onSelect: (userId: number | null) => void;
}

/**
 * Dropdown selector for choosing a Project Manager to view their account.
 * Only shown to admins.
 *
 * The component name is intentionally retained as `EstimatorSelector` for now;
 * the type-name rename (Estimator → ProjectManager) is deferred to a future
 * sweep across `features/commissions/`.
 */
export function EstimatorSelector({ selectedUserId, onSelect }: EstimatorSelectorProps) {
  const { projectManagers, isLoading } = useProjectManagers();

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const value = e.target.value;
    onSelect(value ? parseInt(value) : null);
  };

  return (
    <div className="max-w-sm">
      <Label htmlFor="estimator">Project Manager</Label>
      <Select
        id="estimator"
        value={selectedUserId?.toString() ?? ''}
        onChange={handleChange}
        disabled={isLoading}
      >
        <option value="">Select a project manager...</option>
        {projectManagers.map((pm) => (
          <option key={pm.id} value={pm.id.toString()}>
            {pm.firstName} {pm.lastName}
          </option>
        ))}
      </Select>
    </div>
  );
}
